import { createRequestHelper } from '@utils/swr'
import { type FastOrderMallRequest } from '../types/apiRequest'
import { type FastOrderBrandsResponse } from '../types/apiResponse'
import { type FortuneApis } from '../types/apis'

const {
  useRequest,
} = createRequestHelper<FortuneApis['get']['fastOrderBrands'], FastOrderBrandsResponse, FastOrderMallRequest>({
  client: 'fortune',
  key: params => params?.mall_code ? `/cross-brand-malls/${params.mall_code}/fast-order/brands` : null,
  isImmutable: true,
})

export const useApiFastOrderBrands = useRequest
